import { render } from "./CoInvestLenders.vue?vue&type=template&id=47792b54"
import script from "./CoInvestLenders.vue?vue&type=script&lang=js"
export * from "./CoInvestLenders.vue?vue&type=script&lang=js"

import "./CoInvestLenders.vue?vue&type=style&index=0&id=47792b54&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__